import { computed, observable, action, makeObservable } from 'mobx';
import { apiService } from '../services/api.service';
import { history } from 'fn-common-ui';
import config from 'config';

const CROSS_TAB_LOGOUT_KEY = 'fpse-voluntary-logout';

class UserStore {

  constructor() {
    makeObservable(this);
    window.addEventListener('storage', (event) => {
      if (event.key === CROSS_TAB_LOGOUT_KEY && event.newValue === 'true') {
        localStorage.removeItem(CROSS_TAB_LOGOUT_KEY);
        window.location.replace(config.haloLogout);
      }
    });
  }

  @action revalidateUser() {
    //throttle validation
    if (this.awaitingValidation) {
      //return promise to execute once flag is cleared
      return this.validationPromise;
    } else {
      return this.validateUser();
    }
  }

  @action validateUser() {
    const success = (res) => {
      this.initUserObject(res.data);
      this.awaitingValidation = false;
      this.validationPromise = '';
    };

    const fail = (err) => {
      if(err.response.status === 401) {
        if(!this.userValidationDone){
          //Redirect to Halo
          window.location.replace(config.haloLogin);
          throw new Error('Auth failed - redirecting to SSO login...');
        } else {
          //Redirect to session timeout page
          //history.replace('/error/session-timeout');
          window.location.replace(config.haloLogin);
          throw new Error('Session timed out');
        }
      } else if (err.response.status === 403) {
        //this is not an authorized user for anything
        this.authentic_user = false;
        this.userValidationDone = true
        //throw error to reject promise
        throw new Error('Authorization');
      }
      this.awaitingValidation = false;
      this.validationPromise = '';
    }

    this.awaitingValidation = true;
    //store the promise for return
    this.validationPromise = apiService.validateUserData().then(success, fail);
    return this.validationPromise;
  }

  @action initUserObject(tk_response) {
    let tk_array = tk_response.split('.');
    let user_obj = JSON.parse(window.atob(tk_array[1]));
    this.condtionUserObj(user_obj);
    this.api_token = tk_response;
    this.checkPermissions();
    this.userValidationDone = true;
  }

  @action logoutUser() {
    apiService.logoutUser().then(() => {
      localStorage.setItem(CROSS_TAB_LOGOUT_KEY, 'true');
      window.location.replace(config.haloLogout);
    }).catch((err) => {
      console.error('Received error on logout: ', err);
      localStorage.setItem(CROSS_TAB_LOGOUT_KEY, 'true');
      window.location.replace(config.haloLogout); //go to halo logout anyway
    });
  }

  checkPermissions() {
    if (this.user.roles.indexOf('G_FN_DEV') !== -1) {
      this.authentic_user = true;
    } else {
      this.authentic_user = false;
    }
  }

  addFlagBasedRoles() {
    if(this.user.isPremierUser){
      const ADMIdx = this.user.roles.indexOf('G_FN_ADM')
      const SUBIdx = this.user.roles.indexOf('G_FN_SUB')
      if(ADMIdx > -1){
        this.user.roles[ADMIdx] = 'G_FN_ADM.P'
      }
      if(SUBIdx > -1){
        this.user.roles[SUBIdx] = 'G_FN_SUB.P'
      }
    }
  }

  condtionUserObj(userInfo) {
    this.user.uid = userInfo.id;
    this.user.email = userInfo.email;
    this.user.firstName = userInfo.firstName;
    this.user.lastName = userInfo.lastName;
    this.user.roles = userInfo.roles;
    this.user.username = userInfo.username;

    if(userInfo.authorizations && userInfo.authorizations.length > 0) {
      this.user.pse = Object.keys(userInfo.authorizations[0])[0];
      this.user.isPremierUser = userInfo.authorizations[0].isPremierUser || false;
    }
    this.addFlagBasedRoles()
  }

  clearUser() {
    this.user = {};
    this.api_token = '';
    this.userValidationDone = false;
    this.authentic_user = false;
  }

  @computed get fullName () {
    return `${this.user.firstName} ${this.user.lastName}`;
  }


  @observable user = {};
  @observable api_token = '';
  @observable userValidationDone = false;
  @observable authentic_user = false;
  @observable validationPromise = '';
}

export const userStore = new UserStore();